// src/pages/HomePage.js

import React from 'react';
import HeroDiscovery from '../JSComponents/HeroDiscovery';
import BiggestDealsSection from '../JSComponents/BiggestDealsSection';
import ProductDisplaySection from '../JSComponents/ProductDisplaySection';
import CategoryShowcase from '../JSComponents/CategoryShowcase';
import PartnerBrandsSection from '../JSComponents/PartnerBrandsSection';
import TrendingSection from '../JSComponents/TrendingSection';
import PriceRangeSection from '../JSComponents/PriceRangeSection';
import SavingsCounter from '../JSComponents/SavingsCounter';

function HomePage({ currentUser }) {
  return (
    <>
      <HeroDiscovery />

      <div id="stockroom-browse-start">
        <BiggestDealsSection currentUser={currentUser} />
        <ProductDisplaySection currentUser={currentUser} />
        <CategoryShowcase />
        <PartnerBrandsSection />
        <TrendingSection currentUser={currentUser} />
        <PriceRangeSection />
        <SavingsCounter />
      </div>
    </>
  );
}

export default HomePage;
